<template>
    <div>
        <button v-if="!isShowForm && !isSent" @click="isShowForm = true" class="btn full-width">
            Добавить отзыв
        </button>

        <div v-if="isShowForm && !isSent" class="review-form-wrapper">
            <form @submit.prevent="sendReview" class="form-review-add">
                <!-- Оценка -->
                <div class="form-group">
                    <label for="rating">Оценка <span>*</span></label>
                    <div class="form-rating">
                        <div class="form-check" v-for="index in 5" :key="index">
                            <input
                                class="form-check-input form-control"
                                type="radio"
                                v-model="review.rating"
                                :id="'rating-' + index"
                                :value="index"
                            />
                            <label class="form-check-label" :for="'rating-' + index">
                                <i class="fa-star" :class="(review.rating >= index) ? 'fas' : 'far'"></i>
                            </label>
                        </div>
                    </div>
                    <span v-if="v$.review.rating.$dirty && v$.review.rating.required.$invalid"
                          class="helper-text invalid">Поставьте оценку</span>
                </div>

                <!-- Имя -->
                <div class="form-group">
                    <label for="name">Имя <span>*</span></label>
                    <input
                        id="name"
                        type="text"
                        v-model="review.name"
                        class="form-control"
                        :class="{
              invalid:
                v$.review.name.$dirty &&
                (v$.review.name.required.$invalid || v$.review.name.minLength.$invalid)
            }"
                    />
                    <span v-if="v$.review.name.$dirty && v$.review.name.required.$invalid"
                          class="helper-text invalid">Поле обязательное</span>
                    <span v-else-if="v$.review.name.$dirty && v$.review.name.minLength.$invalid"
                          class="helper-text invalid">Минимум 4 символа</span>
                </div>

                <!-- Текст отзыва -->
                <div class="form-group">
                    <label for="text">Отзыв</label>
                    <textarea
                        id="text"
                        v-model="review.text"
                        class="form-control"
                        :class="{
              invalid: v$.review.text.$dirty && v$.review.text.minLength.$invalid
            }"
                    ></textarea>
                    <span v-if="v$.review.text.$dirty && v$.review.text.minLength.$invalid"
                          class="helper-text invalid">Слишком коротко</span>
                </div>

                <!-- Ошибка -->
                <div v-if="alert" class="helper-text invalid mb-3">{{ alert }}</div>

                <!-- Кнопка -->
                <button class="btn full-width" type="submit" :disabled="isSending">Отправить</button>
            </form>
        </div>

        <div v-if="isSent" class="review-sent-message">
            <p>Ваша оценка была отправлена! Вскоре она отобразится на сайте!</p>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, computed, nextTick } from 'vue'
import useVuelidate from '@vuelidate/core'
import { minLength, required } from '@vuelidate/validators'
import axios from 'axios'
import { useStore } from 'vuex'

// --- Store и State ---
const isShowForm = ref(false)
const isSent = ref(false)
const isSending = ref(false)
const alert = ref('')
const store = useStore()

// --- Структура отзыва (объект, как в checkout) ---
const review = reactive({
    name: '',
    rating: null,
    text: ''
})

// --- Валидация ---
const rules = computed(() => ({
    review: {
        name: { required, minLength: minLength(4) },
        rating: { required },
        text: { minLength: minLength(10) }
    }
}))
const v$ = useVuelidate(rules, { review })

// --- Метод отправки ---
const sendReview = async () => {
    v$.value.$touch()
    if (v$.value.$invalid) {
        await nextTick()
        const el = document.querySelector('.form-group .invalid')
        if (el) {
            const domRect = el.getBoundingClientRect()
            window.scrollTo({
                left: window.scrollX,
                top: domRect.top + window.scrollY - 100,
                behavior: 'smooth'
            })
        }
        return
    }
    if (isSending.value) return
    isSending.value = true
    alert.value = ''
    try {
        const res = await axios.post('/darkrogua/babylon/api/Product@makeReview', {
            name: review.name,
            rating: review.rating,
            comment: review.text,
            product_id: store.getters.productData?.id || 0
        })
        if (res.data && !res.data.alert) {
            isSent.value = true
            isShowForm.value = false
        } else {
            alert.value = res.data.alert || 'Ошибка при отправке'
        }
    } catch (e) {
        alert.value = 'Ошибка при отправке'
    } finally {
        isSending.value = false
    }
}
</script>

<style >

</style>
